//import $ from "jquery";
//import _ from "lodash";
//import popper from "popper.js";
//import bootstrap from "bootstrap";
//import Cookie from "js-cookie";
import LocStore from './class.localStorage.js';
import ShopCookie from './class.cookie.js';

window.LocStore = LocStore;
window.ShopCookie = ShopCookie;

class IndexShop {
	constructor(ssr){
		this.ssr = ssr;
	}

	getId(id) {
		let ele = document.querySelector('#'+id);
		if( ele != (null || undefined) ) return document.getElementById(id);
	}

	changeMini(loc, name, key){
		setTimeout( async () => {
			//console.log( key, '|Key: ', loc.getLS(key) );
			let counter = await loc.getLS(key)['length'];
		  name['innerHTML'] = (counter || 0);
		}, 0);
	}

	setHead(tag) {
		let href = document.location.pathname.split('/');
		let page = (href[href.length - 1]).split('.')[0];
		let title = document.querySelector(tag).textContent;
		if ( this.ssr[tag][page] ) {
			document.querySelector(tag).textContent = this.ssr[tag][page];
			console.log( 'If: ', this.ssr[tag][page] );
		} else {
			document.querySelector(tag).textContent = this.ssr[tag]['default'];
			console.log( 'Else: ', title, '|', page );
		}
		//console.log( 'title: ', document.querySelector(tag).textContent );
	}
}

  /* if cookies */
  const ssr = {
  	title: {
  		index: 'Index title',
  		pricing: 'pricing, filter goods',
  		comparator: 'Compare goods',
  		basket: 'Basket title',
  		default: 'Default title',
  	},
  	meta: {
  		index: '--',
  		pricing: '--',
  		comparator: '--',
  		basket: '--',
  		default: '--',
  	}
  }
  let kek = new IndexShop(ssr);
  let ls = new LocStore();
  let cookObj = new ShopCookie();
  let cook = cookObj.getCookie('read-policy');
  if( cook === undefined ) cookObj.setCookie('read-policy', 'sure', {expires: 365, path: '/'});
  if( cook === 'sure' ) document.querySelectorAll('.box-alert--fixed')[0].classList.add('hide');

  //let itemComp = ls.getLS('itemCompare');
  //let itemBasket = ls.getLS('itemBuy');

  ls.initLS('itemCompare');
  ls.initLS('itemBuy');

  /* mini: Compare, Basket */
  kek.setHead('title');
  kek.changeMini(ls, miniCompare, 'itemCompare');
  kek.changeMini(ls, miniBasket, 'itemBuy');

/*** Remove cookie-box ***/
	//document.getElementById('remove-alarm--cookie').addEventListener("click",
	kek.getId('remove-alarm--cookie').addEventListener("click", 
		function(e){
		  e.target.closest('.box-alert--fixed').remove();
	  }
	);

	/* set-get current product */
	if (!cookObj.getCookie('item-current')){
		cookObj.setCookie('item-current', '(Used) iPhone X 5.8 inch 4G Phablet');
	}

	document.addEventListener("click", function(e)
	{ 
		let target = e.target;
		if ( target.classList.contains('navbar-toggler-icon') ){
			target.closest('.navbar-toggler')['classList']['toggle']('collapsed');
			navbarNavAltMarkup['classList']['toggle']('show');
			return false;
		}

		/* compare page */
	  if( target.classList.contains('item-compare') ){
			let str = target.closest('[data-model]').dataset.model;
			ls.setLS('itemCompare', str);
      kek.changeMini(ls, miniCompare, 'itemCompare');
		}

		if( target.classList.contains('compare-clean') ){
	    kek.changeMini(ls, miniCompare, 'itemCompare');
		}

		/* buy item */
		if( target.classList.contains('item-buy') ){
			let str = target.closest('[data-model]').dataset.model;
			//console.log('Str: ', str);
			ls.setLS('itemBuy', str);
			kek.changeMini(ls, miniBasket, 'itemBuy');
		}

		/* remove All item in basket */
		if( target.classList.contains('basket-clean') ){
			kek.changeMini(ls, miniBasket, 'itemBuy');
		}

		/* next event */
		let el = e.target.closest('[data-model]');
		if ( el == null || el.dataset.model === '') return;

			let ku = cookObj.getCookie('item-current');
			let item_phone = el.dataset.model;
	    //if( ku.length === 0 ) {
	    	//Cookie.set('item-current', item_phone, {expires: 365, path: '/'});
	    	cookObj.setCookie('item-current', item_phone);
	    //}
  }, false);

  /*window.addEventListener("storage", function(event)
	{ 
		let target = event;
		console.log('Event storage: '+ target.key);

	}, false);*/